<div class="messagerie page container">
    <div style="width: 320px;">
        <app-speakers-list [speakersList]="this.speakers" (selectEvent)="this.selectSpeaker($event)" />
    </div>
</div>
